@if (formControl()) {
<div class="email form-group">
    <mat-form-field class="form-field">
        <input matInput [placeholder]="meta().name" [formControl]="formControl()!" [readonly]="readonly()">
        @if (formControl()?.value && !readonly()) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="formControl()!.setValue('')">
            <mat-icon>close</mat-icon>
        </button>
        }
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        @if (formControl()?.hasError('email') && !formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is invalid
        </mat-error>
        }
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
